import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { changeHeaders } from "../request";
import { DeviPayload } from "../../models/deviModel";
import { DeviBannerData } from "../../models/deviBannerModel";
import { getTariffPrices } from "./api";
import { TariffPricesApiResponse } from "../../models/financesModel";
import { SubscriptionInfoResponse } from "../../models/subscriptionModel";

export const deviApi = createApi({
    reducerPath: "devi/api",
    baseQuery: fetchBaseQuery({
        baseUrl: "/api/v1/",
        prepareHeaders: (headers, { getState }) =>
            changeHeaders(headers, { getState }),
    }),
    tagTypes: ["Localized"],
    endpoints: (build) => ({
        getDeviPosts: build.query<DeviPayload, { locale?: string } | void>({
            query: (arg) => {
                const locale =
                    typeof arg === "object" && arg?.locale
                        ? arg.locale
                        : undefined;
                return locale
                    ? `devi?locale=${encodeURIComponent(locale)}`
                    : "devi";
            },
            providesTags: [{ type: "Localized" }],
        }),

        getTariffPrices: build.query<TariffPricesApiResponse, string>({
            query: (language) => getTariffPrices(language),
            providesTags: [{ type: "Localized" }],
        }),

        getDeviBanner: build.query<DeviBannerData, { locale?: string } | void>({
            query: (arg) => {
                const locale =
                    typeof arg === "object" && arg?.locale
                        ? arg.locale
                        : undefined;
                return locale
                    ? `devi/banner?locale=${encodeURIComponent(locale)}`
                    : "devi/banner";
            },
            providesTags: [{ type: "Localized" }],
        }),

        getSubscriptionInfo: build.query<SubscriptionInfoResponse, void>({
            query: () => "devi/info",
        }),

        getDeviCount: build.query<number, void>({
            query: () => "devi/count",
        }),
    }),
});

export const {
    useGetDeviPostsQuery,
    useLazyGetDeviPostsQuery,
    useGetDeviBannerQuery,
    useGetTariffPricesQuery,
    useGetSubscriptionInfoQuery,
    useGetDeviCountQuery,
    endpoints,
    util,
} = deviApi;